module.exports = __webpack_public_path__ + "static/media/result1.124457c7.png";